import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { firestore } from '../../../../../firebase'
import TeamSquadImage from './TeamSquadImage'

function TeamPlayersFB({ teamId, playersAPI }) {
    const [players, setPlayers] = useState([])
    const [playersArray, setPlayersArray] = useState(playersAPI)

    useEffect(() => {
        try {
            const playersRef = firestore.collection('team-players')

            playersRef.where('team_id', '==', teamId).onSnapshot(({ docs }) => {
                const players = docs.map((doc) => {
                    return { id: doc.id, ...doc.data() }
                })
                setPlayers(players)
            })
        } catch (error) {}
    }, [teamId])

    return (
        <div className="row my-3">
            {playersAPI?.map((player, index) => {
                return (
                    <div
                        className="col-6 col-md-4 col-lg-3 col-xl-2 mt-2"
                        key={index}
                    >
                        <div className="card">
                            <Link to={`/players-api/${player.player_id}`}>
                                <TeamSquadImage
                                    player={player}
                                    playersFB={players}
                                    playersAPI={playersAPI}
                                />
                            </Link>
                            <div className="py-1 px-2">
                                <small>{player.player_name}</small>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
export default TeamPlayersFB
